import styled from 'styled-components';
import { colors } from 'globalStyles';

// Deliberately the same centred column as each list's EmptyList — same width,
// same rhythm, same call-to-action slot — so the two states read as siblings
// rather than as two unrelated screens. Everything that differs is carrying
// meaning: the danger tokens and the icon say "this went wrong", where the
// empty state's muted grey says "there is nothing here".
export const StyledListError = styled.div`
  text-align: center;
  color: ${colors.DANGER_FG};
`;

export const ErrorTitle = styled.p`
  font-weight: bold;
  padding-top: 8px;
`;

// BODY, not the empty state's muted grey. The empty state can afford to
// recede; this copy is the explanation of a failure and has to be readable —
// MEDIUM_GRAY on the page background is ~3.6:1, under the 4.5:1 AA floor for
// body text, and dropping to it here would be inheriting a defect rather than
// a convention.
export const ErrorText = styled.p`
  color: ${colors.BODY};
  margin: 0 auto;
  max-width: 420px;
  padding-bottom: 24px;
`;

// The list's own retry, not a page-level one, so it takes the secondary
// treatment rather than the gradient primary — the page's primary action
// ("New Channel", "Download CSV") is still the one in the header.
export const RetryButton = styled.button`
  background: ${colors.DANGER_BG};
  border: 1px solid ${colors.DANGER_FG};
  border-radius: 3px;
  color: ${colors.DANGER_FG};
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  line-height: 17px;
  padding: 0.8em 1.5em;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover:not(:disabled) {
    background: ${colors.DANGER_FG};
    color: ${colors.WHITE};
  }

  &:active:not(:disabled) {
    background: ${colors.DANGER_FG};
    color: ${colors.WHITE};
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 2px solid ${colors.DANGER_FG};
    outline-offset: 2px;
  }

  /* "Retrying…" is a status, not just a dimmed control, so it stays legible —
     the shared button style's 0.1 would make the one word telling the user
     something IS happening the hardest thing on screen to read. */
  &:disabled {
    cursor: progress;
    opacity: 0.75;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active:not(:disabled) {
      transform: none;
    }
  }
`;
